import React from 'react';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import './BookingDetailsHeader.less';
import { ScreenHeaderProps } from '../../types/carTypes';

const { Text } = Typography;

const BookingDetailsHeader = ({ bookingNumber, locationID, car } : ScreenHeaderProps) => {
    const navigate = useNavigate();

    const carDescription = car?.deployable_description;
    const locationDescription = car?.location_description || 'No current location';

    const onClickCar = () => navigate('/fleet/car?id=' + car?.id);
    const onClickLocation = () => navigate('/fleet/location?id=' + locationID);

    return (
        <>
            {bookingNumber && bookingNumber > 0 ? <Text className="booking-number">Booking #{bookingNumber}</Text> : null}
            <Text onClick={onClickCar} className="car-description">{carDescription}</Text>
            <Text onClick={onClickLocation} className="location-description">{locationDescription}</Text>
            {bookingNumber === 0 && <Text className="licence-plate">{car && car.licence_plate?.toUpperCase()}</Text>}
        </>
    );
}

export default BookingDetailsHeader;
